import { CustomTable } from "../../../shared";
import { createColumnHelper } from "@tanstack/react-table";

export const ProductionChartTemplateDialog = (props) => {
  const { templateList, onSearchChange } = props;

  const columnHelper = createColumnHelper(templateList);

  const columns = [
    columnHelper.accessor("template_name", {
      header: "Template",
    }),
  ];
  return (
    <CustomTable
      defaultData={templateList}
      columns={columns}
      headerText="Templates"
      subRow={"subRows"}
      allRowsExpanded={true}
      manualPagination={true}
      isPagination={false}
      onSearchChange={onSearchChange}
      // customRowStyle={(row) => {
      //   return !row.depth ? { borderBottom: "none" } : null;
      // }}
      rightContent=" "
      isInTab
      tableHeaderStyles={{
        position: "sticky",
        top: 0,
        backgroundColor: "background.paper",
        zIndex: 99,
      }}
      tableStyle={{ overflow: "unset" }}
    />
  );
};
